import React, { ReactNode } from 'react';
import { useAuth } from '@/core/auth/AuthContext';

/**
 * PageContainer - Bao bọc toàn bộ nội dung một màn hình chức năng.
 */
export function PageContainer({ children, className = '' }: { children: ReactNode, className?: string }) {
  const { isImpersonating, stopImpersonating, profile } = useAuth();

  return (
    <div className={`w-full flex-1 min-w-0 ${className} relative flex flex-col`}>
      {isImpersonating && (
        <div className="bg-red-600 text-white px-4 py-2.5 flex items-center justify-center gap-2 text-sm font-semibold z-50 rounded-b-xl shadow-lg shadow-red-600/20 sticky top-0 mb-4 mx-4 border border-red-500">
          <i className="ri-spy-fill animate-pulse text-lg" />
          <span>Phiên ẩn danh: Đang điều khiển ({profile?.full_name})</span>
          <button 
            onClick={stopImpersonating}
            className="ml-4 bg-white/20 hover:bg-white/30 px-3 py-1.5 rounded-lg transition-colors text-xs font-bold shadow-sm"
          >
            Thoát ngay
          </button>
        </div>
      )}
      {children}
    </div>
  );
}
